import React from 'react'

interface DonateButtonProps {
  label: string
  href: string
  colorClass: string
}

const DonateButton: React.FC<DonateButtonProps> = ({ label, href, colorClass }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`block w-full text-center text-white font-semibold py-4 px-6 rounded-lg shadow-sm hover:opacity-90 transition-opacity ${colorClass}`}
    >
      {label}
    </a>
  )
}

const DonatePaypal: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-blue-800 text-white py-12 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Ross Street Masjid</h1>
        <p className="text-lg md:text-xl">Support Your Mosque - Make a Donation</p>
      </header>

      <main className="flex-1 px-6 py-10">
        <div className="max-w-md mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Choose a Cause to Donate
          </h2>

          <div className="space-y-4">
            <DonateButton
              label="Donate to Zakat"
              href="https://www.paypal.com/donate/?hosted_button_id=LM3825YCMJWF4"
              colorClass="bg-sky-500"
            />
            <DonateButton
              label="Donate to Fitrana"
              href="https://www.paypal.com/donate/?hosted_button_id=AF8UDF4MRHFGQ"
              colorClass="bg-emerald-500"
            />
            <DonateButton
              label="Jumma Donations"
              href="https://www.paypal.com/donate/?hosted_button_id=HCP4HQRTZZF36"
              colorClass="bg-amber-500"
            />
            <DonateButton
              label="Donate to New Building Fund"
              href="https://www.paypal.com/donate/?hosted_button_id=ES7SDQRZP9DNC"
              colorClass="bg-red-500"
            />
            <DonateButton
              label="Donate for New Carpet"
              href="https://www.paypal.com/donate/?hosted_button_id=2FWH2JWYJ3X7J"
              colorClass="bg-violet-500"
            />
          </div>
        </div>
      </main>
    </div>
  )
}

export default DonatePaypal
